import API from '@/api/index';

const monitor = {
  mutations: {},

  actions: {
    GetCommandByImei({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.monitor
          .GetCommandByImei(data)
          .then(response => {
            const result = response.data;
            if (Array.isArray(result)) {
              resolve(result);
            }
            else if (!result.code || result.code === 'Successful') {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => reject(error));
      });
    },

    SendCommandToDevice ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.monitor.SendCommandToDevice(data)
          .then(({ status, data }) => {
            if (status === 200) resolve(true);
            else reject(data);
          })
          .catch(reject);
      });
    },
  }
};

export default monitor;



// WEBPACK FOOTER //
// ./src/store/modules/monitor.js